require('./accountPrecautionaryWarnings.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const { AccountPrecautionaryWarningsDetail } = require('components/contactCenter/accountPrecautionaryWarnings/accountPrecautionaryWarningsDetail/accountPrecautionaryWarningsDetail');
// @helpers
const { formatText } = require('core/i18n').i18n;

class AccountPrecautoryWarnings extends React.Component {

    buildBreadcrumbMap() {
        const { immAccount} = this.props;
        const accountId = immAccount.get('accountId');
        const breadcrumpMap = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-precautionaryWarnings')
            }
        ];

        return breadcrumpMap;
    }

    buildHeader() {
      const breadcrumb = this.buildBreadcrumbMap();
      const title = formatText('accountPrecautionaryWarnings-title');

      return (
          <OKHeaderCC
              title={title}
              breadcrumbConfig={breadcrumb}
              showBreadBrumb={true}
          />
      );
    }

    buildDetails() {
        const { immAccount, immAccountPrecautionaryWarnings } = this.props;
        let content = <LoadingSection />
        if (immAccount) {
            content = (
                <AccountPrecautionaryWarningsDetail
                    immAccount={immAccount}
                    immWarnings={immAccountPrecautionaryWarnings}
                />
            );
        }

        return content;
    }

    render() {
        const header = this.buildHeader();
        const details = this.buildDetails();

        return (
            <div>
                {header}
                {details}
            </div>
        );
    }

}

AccountPrecautoryWarnings.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immAccountPrecautionaryWarnings: PropTypes.object.isRequired,
};

module.exports = AccountPrecautoryWarnings;
